import React, { useState } from "react";
import "../styles/DicgcPage.css";

export default function DicgcPage() {

const [openFAQ,setOpenFAQ] = useState(null);

const toggleFAQ=(index)=>{
setOpenFAQ(openFAQ===index ? null : index);
};

const faqData=[
{
q:"What is DICGC?",
a:"DICGC (Deposit Insurance and Credit Guarantee Corporation) provides insurance cover for bank deposits and protects depositors in case of bank failure."
},
{
q:"How much deposit is insured?",
a:"Deposits are insured up to ₹5,00,000 per depositor per bank under the DICGC scheme."
},
{
q:"Are cooperative bank deposits insured?",
a:"Yes. Deposits in cooperative banks are covered under the DICGC deposit insurance scheme."
},
{
q:"Which types of accounts are covered?",
a:"Savings accounts, current accounts, fixed deposits and recurring deposits are covered."
}
];

return (

<div className="dicgcpage-wrapper">

{/* HERO */}

<section className="dicgcpage-hero">

<h1 className="dicgcpage-hero-title">
Deposit Insurance & Credit Guarantee Corporation (DICGC)
</h1>

<p className="dicgcpage-hero-tagline">
Your deposits with our bank are protected under the Deposit Insurance Scheme ensuring financial security and trust.
</p>

</section>



{/* ABOUT */}

<section className="dicgcpage-about-section">

<div className="dicgcpage-about-card">

<p>
Cooperative banks in States/Union Territories with amended Cooperative
Societies Acts, granting RBI authority to order winding up or supersede
management committees, are covered by the Deposit Insurance Scheme.
Currently, all cooperative banks fall under DICGC coverage.
</p>

</div>

</section>



{/* HIGHLIGHTS */}

<section className="dicgcpage-highlight-section">

<h2>Deposit Protection Highlights</h2>

<div className="dicgcpage-highlight-grid">

<div className="dicgcpage-highlight-card">
<h3>₹5,00,000</h3>
<p>Maximum deposit insurance coverage per depositor</p>
</div>

<div className="dicgcpage-highlight-card">
<h3>All Cooperative Banks</h3>
<p>Covered under the DICGC deposit insurance scheme</p>
</div>

<div className="dicgcpage-highlight-card">
<h3>RBI Subsidiary</h3>
<p>DICGC operates under Reserve Bank of India</p>
</div>

</div>

</section>



{/* DOWNLOAD SECTION */}

<section className="dicgcpage-download-section">

<h2>Download Deposit Insurance Returns</h2>

<div className="dicgcpage-download-grid">

<div className="dicgcpage-download-card">

<h3>DI Half-Yearly Return</h3>

<p>Ending 31/03/2026</p>

<a href="/forms/Deposit_Insurance_Return_31032026.pdf" className="dicgcpage-download-btn">
Download Report
</a>

</div>


<div className="dicgcpage-download-card">

<h3>DI Half-Yearly Return</h3>

<p>Ending 30/09/2026</p>

<a href="/forms/Deposit_Insurance_Return_30092026.pdf" className="dicgcpage-download-btn">
Download Report
</a>

</div>

</div>

</section>



{/* FAQ */}

<section className="dicgcpage-faq-section">

<h2>Frequently Asked Questions</h2>

<div className="dicgcpage-faq-container">

{faqData.map((faq,index)=>(
<div key={index} className="dicgcpage-faq-item">

<div
className="dicgcpage-faq-question"
onClick={()=>toggleFAQ(index)}
>

{faq.q}

<span>{openFAQ===index ? "-" : "+"}</span>

</div>

{openFAQ===index && (
<div className="dicgcpage-faq-answer">

{faq.a}

</div>
)}

</div>
))}

</div>

</section>

</div>

);

}